export default function Navigation() {
  const navigation = document.querySelector('.navigation');
  const openNavigationButton = document.querySelector('.js-navigation');
  const closeNavigationButton = document.querySelector('.navigation__button--close');
  const navigationIsOpenClass = 'navigation--is-open';
  const header = document.querySelector('.header');
  const headerHeight = header.offsetHeight;
  const breakpoint = 992;

  // Needed to make the logo stop at right position when scrolling
  setHeaderHeight();
  window.addEventListener('resize', setHeaderHeight);

  function openNavigation() {
    navigation.classList.add(navigationIsOpenClass);
    document.body.style.overflow = 'hidden';
  };

  function closeNavigation () {
    navigation.classList.remove(navigationIsOpenClass);
    document.body.style.overflow = 'initial';
  };

  function setHeaderHeight () {
    window.innerWidth > breakpoint ?
      header.style.height = (headerHeight + navigation.offsetHeight) + 'px' :
      header.style.height = '7rem';
  }

  openNavigationButton.addEventListener('click', () => openNavigation());
  closeNavigationButton.addEventListener('click', () => closeNavigation());
};
